import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import moment from 'moment';
import { LoadingOutlined, PauseOutlined, CaretRightOutlined, RetweetOutlined } from '@ant-design/icons';
import { Slider } from 'antd';
import styled from 'styled-components';
import VolumeInput from './audio-volume-input.component';
import { getColor, getSize } from '../../hooks';
import { useAudioPlayer } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledContainer = styled.div.withConfig({
  displayName: "audio-player-v2component__StyledContainer",
  componentId: "sc-129czul-0"
})(["display:flex;align-items:center;padding:", " ", ";min-height:", ";background-color:", ";border:1px solid ", ";border-radius:", ";box-shadow:0 1px 3px rgba(0,0,0,0.05);transition:border-color 0.2s,box-shadow 0.2s;&:hover{border-color:", ";}"], getSize('padding12'), getSize('padding16'), getSize('padding48'), getColor('fillBgSub'), getColor('shapeBorder'), getSize('radius'), getColor('textIntDefault'));
var StyledAudio = styled.audio.withConfig({
  displayName: "audio-player-v2component__StyledAudio",
  componentId: "sc-129czul-1"
})(["pointer-events:", ";opacity:", ";width:100%;"], function (_ref) {
  var $disabled = _ref.$disabled;
  return $disabled ? 'none' : 'auto';
}, function (_ref2) {
  var $disabled = _ref2.$disabled;
  return $disabled ? 0.6 : 1;
});
var StyledDuration = styled.div.withConfig({
  displayName: "audio-player-v2component__StyledDuration",
  componentId: "sc-129czul-2"
})(["margin-right:", ";font-size:", ";color:", ";"], getSize('padding16'), getSize('typo12'), getColor('contentBody'));
var StyledProgressBar = styled(Slider).withConfig({
  displayName: "audio-player-v2component__StyledProgressBar",
  componentId: "sc-129czul-3"
})(["width:100%;flex:1;margin-right:", ";"], getSize('padding16'));
var StyledPauseOutlined = styled(PauseOutlined).withConfig({
  displayName: "audio-player-v2component__StyledPauseOutlined",
  componentId: "sc-129czul-4"
})(["font-size:", ";margin-right:", ";color:", ";cursor:", ";"], getSize('typo24'), getSize('padding16'), function (_ref3) {
  var $disabled = _ref3.$disabled;
  return $disabled ? getColor('textIntDisabled') : getColor('textIntDefault');
}, function (_ref4) {
  var $disabled = _ref4.$disabled;
  return $disabled ? 'not-allowed' : 'pointer';
});
var StyledCaretRightOutlined = styled(CaretRightOutlined).withConfig({
  displayName: "audio-player-v2component__StyledCaretRightOutlined",
  componentId: "sc-129czul-5"
})(["font-size:", ";margin-right:", ";color:", ";cursor:", ";"], getSize('typo24'), getSize('padding16'), function (_ref5) {
  var $disabled = _ref5.$disabled;
  return $disabled ? getColor('textIntDisabled') : getColor('textIntDefault');
}, function (_ref6) {
  var $disabled = _ref6.$disabled;
  return $disabled ? 'not-allowed' : 'pointer';
});
var StyledLoadingOutlined = styled(LoadingOutlined).withConfig({
  displayName: "audio-player-v2component__StyledLoadingOutlined",
  componentId: "sc-129czul-6"
})(["font-size:", ";margin-right:", ";color:", ";"], getSize('typo24'), getSize('padding16'), getColor('textIntDefault'));
var StyledReplayWrapper = styled.div.withConfig({
  displayName: "audio-player-v2component__StyledReplayWrapper",
  componentId: "sc-129czul-7"
})(["margin-right:", ";position:relative;"], getSize('padding16'));
var StyledRetweetOutlined = styled(RetweetOutlined).withConfig({
  displayName: "audio-player-v2component__StyledRetweetOutlined",
  componentId: "sc-129czul-8"
})(["font-size:", ";color:", ";"], getSize('typo24'), function (_ref7) {
  var $hasReplays = _ref7.$hasReplays;
  return $hasReplays ? getColor('textIntDefault') : getColor('textIntDisabled');
});
var StyledReplayCount = styled.div.withConfig({
  displayName: "audio-player-v2component__StyledReplayCount",
  componentId: "sc-129czul-9"
})(["position:absolute;right:-", ";top:-", ";padding:", ";width:", ";height:", ";display:flex;justify-content:center;align-items:center;border-radius:50%;font-size:", ";color:", ";background-color:", ";"], getSize('gap4'), getSize('gap4'), getSize('gap4'), getSize('padding16'), getSize('padding16'), getSize('typo10'), getColor('contentWhite'), function (_ref8) {
  var $hasReplays = _ref8.$hasReplays;
  return $hasReplays ? getColor('contentHeading') : getColor('textIntDisabled');
});
var DisabledReasonMessage = styled.div.withConfig({
  displayName: "audio-player-v2component__DisabledReasonMessage",
  componentId: "sc-129czul-10"
})(["margin-top:", ";font-size:", ";color:", ";text-align:center;display:flex;align-items:center;justify-content:center;gap:", ";"], getSize('padding8'), getSize('typo12'), getColor('textIntHighlighted'), getSize('gap4'));
var AudioStatusInfo = styled.div.withConfig({
  displayName: "audio-player-v2component__AudioStatusInfo",
  componentId: "sc-129czul-11"
})(["margin-top:", ";font-size:", ";color:", ";text-align:center;display:flex;align-items:center;justify-content:center;gap:", ";span{background:", ";padding:", " ", ";border-radius:", ";}"], getSize('padding8'), getSize('typo12'), getColor('contentBody'), getSize('gap12'), getColor('fillBgSub'), getSize('gap4'), getSize('padding8'), getSize('radiusS'));

// Helper function to render time
var renderTime = function renderTime(time) {
  if (!Number.isFinite(time)) return '00:00';
  var duration = moment.duration(time, 'seconds');
  return "".concat(duration.minutes().toString().padStart(2, '0'), ":").concat(duration.seconds().toString().padStart(2, '0'));
};

export var AudioPlayerV2 = function AudioPlayerV2(_ref9) {
  var source = _ref9.source,
      audioId = _ref9.audioId,
      durationProp = _ref9.duration,
      _ref9$audioPlayerConf = _ref9.audioPlayerConfig,
      audioPlayerConfig = _ref9$audioPlayerConf === void 0 ? {} : _ref9$audioPlayerConf,
      _ref9$labels = _ref9.labels,
      labels = _ref9$labels === void 0 ? {} : _ref9$labels,
      _ref9$disabled = _ref9.disabled,
      disabled = _ref9$disabled === void 0 ? false : _ref9$disabled,
      _ref9$isInteractionLo = _ref9.isInteractionLocked,
      isInteractionLocked = _ref9$isInteractionLo === void 0 ? false : _ref9$isInteractionLo,
      _ref9$isCanSeek = _ref9.isCanSeek,
      isCanSeek = _ref9$isCanSeek === void 0 ? false : _ref9$isCanSeek,
      _ref9$disableAudioRul = _ref9.disableAudioRules,
      disableAudioRules = _ref9$disableAudioRul === void 0 ? false : _ref9$disableAudioRul,
      _ref9$allowMultipleAu = _ref9.allowMultipleAudiosPlay,
      allowMultipleAudiosPlay = _ref9$allowMultipleAu === void 0 ? false : _ref9$allowMultipleAu;
  var isRulesDisabled = Boolean(disableAudioRules || audioPlayerConfig.disableAudioRules);
  var effectiveAllowMultipleAudiosPlay = Boolean(allowMultipleAudiosPlay || audioPlayerConfig.allowMultipleAudiosPlay);
  var effectiveIsCanSeek = Boolean(isCanSeek || audioPlayerConfig.isCanSeek || audioPlayerConfig.isAllowedToSeek || isRulesDisabled);
  var effectiveDuration = durationProp !== null && durationProp !== void 0 ? durationProp : audioPlayerConfig.duration;

  var _useAudioPlayer = useAudioPlayer(_objectSpread(_objectSpread({
    audioId: audioId,
    source: source,
    duration: effectiveDuration
  }, audioPlayerConfig), {}, {
    disableAudioRules: isRulesDisabled,
    allowMultipleAudiosPlay: effectiveAllowMultipleAudiosPlay,
    isCanSeek: effectiveIsCanSeek,
    isAutoPlay: isInteractionLocked ? false : audioPlayerConfig.isAutoPlay,
    labels: {
      exhaustedReplays: labels.exhaustedReplays,
      permanentlyDisabled: labels.permanentlyDisabled,
      oneAudioAtTime: labels.oneAudioAtTime,
      permanentlyStopped: labels.permanentlyStopped,
      audioUnavailable: labels.audioUnavailable
    }
  })),
      states = _useAudioPlayer.states,
      actions = _useAudioPlayer.actions,
      audioRef = _useAudioPlayer.audioRef;

  var isPlaying = states.isPlaying,
      isReady = states.isReady,
      isLoadError = states.isLoadError,
      duration = states.duration,
      currentTime = states.currentTime,
      volume = states.volume,
      remainingReplays = states.remainingReplays,
      canPlay = states.canPlay,
      isAudioDisabled = states.isAudioDisabled,
      disabledReason = states.disabledReason,
      audioStatus = states.audioStatus,
      isAllowedToPause = states.isAllowedToPause;
  var togglePlayPause = actions.togglePlayPause,
      seek = actions.seek,
      changeVolume = actions.changeVolume,
      toggleMuteUnmute = actions.toggleMuteUnmute;
  var isDisabledByLock = disabled || isInteractionLocked;
  var isControlLocked = isDisabledByLock || isAudioDisabled || isLoadError;
  var totalDuration = Number.isFinite(duration) && duration > 0 ? duration : Number.isFinite(effectiveDuration) && (effectiveDuration !== null && effectiveDuration !== void 0 ? effectiveDuration : 0) > 0 ? effectiveDuration : 0;
  var progress = totalDuration > 0 ? currentTime / totalDuration * 100 : 0;
  var isSeekDisabled = !canPlay || isControlLocked || !effectiveIsCanSeek || !Number.isFinite(totalDuration) || totalDuration <= 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledContainer, {
      children: [/*#__PURE__*/_jsx(StyledAudio, {
        ref: audioRef,
        $disabled: isControlLocked,
        children: /*#__PURE__*/_jsx("source", {
          src: source
        })
      }, "".concat(audioId !== null && audioId !== void 0 ? audioId : 'audio', "-").concat(source)), !isReady && !isLoadError ? /*#__PURE__*/_jsx(StyledLoadingOutlined, {}) : isPlaying ? /*#__PURE__*/_jsx(StyledPauseOutlined, {
        $disabled: !isAllowedToPause || isControlLocked,
        onClick: !isAllowedToPause || isControlLocked ? undefined : togglePlayPause
      }) : /*#__PURE__*/_jsx(StyledCaretRightOutlined, {
        $disabled: !canPlay || isControlLocked,
        onClick: !canPlay || isControlLocked ? undefined : togglePlayPause
      }), /*#__PURE__*/_jsxs(StyledDuration, {
        children: [renderTime(currentTime), " / ", renderTime(totalDuration)]
      }), /*#__PURE__*/_jsx(StyledProgressBar, {
        disabled: isSeekDisabled,
        value: progress,
        onChange: function onChange(value) {
          if (!isSeekDisabled && Number.isFinite(duration) && duration > 0) {
            var targetTime = value / 100 * duration;

            if (Number.isFinite(targetTime)) {
              seek(targetTime);
            }
          }
        },
        tooltip: {
          formatter: null
        }
      }), audioPlayerConfig.isAllowedToReplay && remainingReplays >= 0 && /*#__PURE__*/_jsxs(StyledReplayWrapper, {
        children: [/*#__PURE__*/_jsx(StyledRetweetOutlined, {
          $hasReplays: remainingReplays > 0
        }), /*#__PURE__*/_jsx(StyledReplayCount, {
          $hasReplays: remainingReplays > 0,
          children: remainingReplays
        })]
      }), /*#__PURE__*/_jsx(VolumeInput, {
        volume: volume,
        onVolumeChange: isControlLocked ? function () {
          return undefined;
        } : changeVolume,
        onToggleMute: isControlLocked ? function () {
          return undefined;
        } : toggleMuteUnmute
      })]
    }), isAudioDisabled && disabledReason && /*#__PURE__*/_jsxs(DisabledReasonMessage, {
      children: ["\u26A0\uFE0F ", disabledReason]
    }), isLoadError && /*#__PURE__*/_jsxs(DisabledReasonMessage, {
      children: ["\u26A0\uFE0F ", labels.audioUnavailable]
    }), isInteractionLocked && labels.clickToStart && /*#__PURE__*/_jsx(DisabledReasonMessage, {
      children: labels.clickToStart
    }), audioStatus && /*#__PURE__*/_jsx(AudioStatusInfo, {
      children: audioStatus.isCompleted && /*#__PURE__*/_jsxs("span", {
        children: ["\u2705 ", labels.completed || 'Completed']
      })
    })]
  });
};